import { render, staticRenderFns } from "./text-dropdown.vue?vue&type=template&id=6f63e143&scoped=true"
import script from "./text-dropdown.vue?vue&type=script&lang=ts"
export * from "./text-dropdown.vue?vue&type=script&lang=ts"
import style0 from "./text-dropdown.vue?vue&type=style&index=0&id=6f63e143&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f63e143",
  null
  
)

export default component.exports